import * as actions from "../actions/AdminEventActions";
import { AdminEventState, initialState } from "../store/AdminEventState";
import buildReducer from "../utils/ReducerBuilder";

export const AdminEventReducer = buildReducer<AdminEventState>(initialState)
    .handle(actions.onEventSubscribed, (state, action) => {
        if (!action.payload)
            return state;

        const subscribedEvents = { ...state.subscribedEvents };
        if (!action.payload.subscribed)
            delete subscribedEvents[action.payload.id];
        else if (action.payload.subscribed)
            subscribedEvents[action.payload.id] = 0;
        console.log("subscribed events", subscribedEvents);

        return {
            ...state,
            subscribedEvents,
        };
    })
    .handle(actions.onEventsUpdated, (state, action) => ({
        ...state,
        events: action.payload || state.events,
    }))
    .handle(actions.onEventUpdatedRemotely, (state, action) => {
        const subscribedEvents = { ...state.subscribedEvents };
        subscribedEvents[action.payload || 0] = new Date().valueOf();
        console.log("subscribed events", subscribedEvents);

        return {
            ...state,
            subscribedEvents,
        };
    })
    .handle(actions.onListEventsUpdated, (state, action) => ({
        ...state,
        listEvents: action.payload || state.listEvents,
    }))
    .handle(actions.onSubEventsUpdated, (state, action) => ({
        ...state,
        subEvents: action.payload || state.subEvents,
    }))
    .handle(actions.toggleLoadingEvent, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingEvent = { ...state.loadingEvent };
        loadingEvent[action.payload.eventId] = action.payload.loading;

        return {
            ...state,
            loadingEvent,
        };
    })
    .handle(actions.toggleLoadingListEvents, (state, action) => ({
            ...state,
            loadingListEvents: action.payload || false,
    }))
    .handle(actions.toggleLoadingSubEvents, (state, action) => ({
            ...state,
            loadingSubEvents: action.payload || false,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AdminEventReducer.ts